<div class="d-flex column reason-wrapper {{ position }}" data-test-id="reason-modal-wrapper" cdkTrapFocus>
  <h6 class="heading medium">
    <span *ngIf="showLabel">
      {{ 'module.requests.text.add-reason' | translate }}
      <span class="text-break">{{ ('common.button.' + actionName | translate) + (fileName ? ' ' + fileName : '') }}:</span>
    </span>

    <div *ngIf="options?.attachmentAvailable" class="attachment-trigger">
      <ng-container *ngIf="fileType$ | async as fileType">
        <button
          aria-label="Add attachments"
          class="icon icon-paperclip"
          mat-icon-button
          type="button"
          [attr.data-test-id]="'add_reason_add_attachments'"
          (click.no-selection)="attachmentInput.click()"
          title="Add attachments for your action"
        ></button>
        <input
          type="file"
          #attachmentInput
          style="display: none"
          [accept]="fileType"
          (input)="onAttachmentsChange()"
          multiple
          [attr.data-test-id]="'add_reason_add_attachments_input'"
        />
      </ng-container>
    </div>
  </h6>
  <div #requestActionContainer style="margin-right: -27px" class="request-action-filelist-container">
    <div
      *ngIf="options?.attachmentAvailable"
      class="attachment-list"
      [ngStyle]="{
        'margin-right': -1 * (attachmentList.scrollHeight > attachmentList.clientHeight ? getScrollbarWidth() + 14 : -14) + 'px'
      }"
      #attachmentList
    >
      <ng-container *ngFor="let fileJob of attachmentFileJobs; let fileJobIndex = index">
        <div class="attachment" *ngIf="!excludedFileJobs.includes(fileJob)">
          <span [title]="fileJob.file.name" class="attachment__name">
            <span [attr.data-test-id]="['add_reason_add_attachments', 'job', fileJobIndex, 'file_name'] | join" class="truncate fs-sm">
              {{ fileJob.file.name }}
            </span>
            <ng-container *ngIf="fileJob.progress">
              <ng-container *ngIf="fileJob.progress | async as progress">
                <mat-progress-bar *ngIf="progress < 100" [value]="progress"></mat-progress-bar>
              </ng-container>
            </ng-container>
          </span>
          <span class="attachment__actions">
            <button
              [attr.aria-label]="'Remove attachment ' + fileJob.file.name"
              class="icon icon-close"
              mat-icon-button
              type="button"
              [attr.data-test-id]="['add_reason_remove_attachment', fileJobIndex] | join"
              (click)="removeAttachment(fileJobIndex)"
            ></button>
          </span>
        </div>
      </ng-container>
    </div>
  </div>
  <div>
    <form [formGroup]="form" [class.mt-1h]="!(!showLabel && !options?.attachmentAvailable)">
      <app-textarea-form
        [autoFocus]="true"
        maxLength="1024"
        formControlName="comment"
        [isRequired]="isRequired"
        showLabel="true"
        inputLabel="{{ this.fieldLabel ?? ('common.label.add-reason' | translate) }}"
        inputClass="w-100 pb-1h"
      ></app-textarea-form>
    </form>
  </div>
  <div class="row">
    <button
      class="button col"
      [ngClass]="isRedConfirmButton ? 'secondary-reject-button' : 'primary-button'"
      type="button"
      (click)="onConfirm()"
      data-test-id="button_reason_confirm"
    >
      {{ 'common.button.' + mainButtonTitle | translate }}
    </button>
    <div class="col-auto"></div>
    <button class="button secondary-button col" type="button" (click)="onCancel()" data-test-id="button_reason_cancel">
      {{ 'common.button.cancel' | translate }}
    </button>
  </div>
</div>
